import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { observer, inject } from 'mobx-react'
import * as styles from './style/index.scss'
import { InputItem, Button, WhiteSpace, Checkbox } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'
import intl from '@utils/intl'
import { LANG, TRYBUY_EVENT_TRACING_PAGE, TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
import { getLang, isEmail } from '@src/utils'
import LangSwitch from '@componentsG/switchLang'
import { createForm, formShape } from 'rc-form';
import { PATTERN } from '@constants/validate';
import { encrypt } from '@utils/aes.js'
import { userStore } from '@src/store/userStore'
interface RegisterProps {
    form: formShape
}

const CheckboxItem = Checkbox.AgreeItem;
@inject('registerStoreG')
@observer
class Register extends ComponentExt<RegisterProps, any> {
    private store: any
    private readonly emailPlaceHolder = intl.formatMessage({ id: 'register.input.email' })
    private readonly imgCodePlaceHolder = intl.formatMessage({ id: 'register.input.imgCode' })
    private readonly verifyCodePlaceHolder = intl.formatMessage({ id: 'register.input.verifyCode' })
    private readonly passwdPlaceHolder = intl.formatMessage({ id: 'register.input.password' })
    private readonly rePasswdPlaceHolder = intl.formatMessage({ id: 'register.input.rePassword' })

    constructor(props) {
        super(props)
        this.store = props.registerStoreG
        this.state = {
            operatorId: null
        }
    }
    async componentDidMount() {
        const url = location.href.split('?iccid=')[1]
        const iccid = url.split('&')[0]
        if(iccid){
            this.setState({
                operatorId: await this.store.getOperatorId(iccid)
            })
        }
        userStore.sendEventTracing({
            pageCode: TRYBUY_EVENT_TRACING_PAGE.TRYBUG_PAGE_REGIST,
            buttonCode: '',
            buttonInfo: ''
        })
    }
    getVerifyCode = (e) => {
        e.stopPropagation() // 阻止父级的点击事件
        const email = this.props.form.getFieldValue('email')
        const imgCode = this.props.form.getFieldValue('imgCode')
        if (!email || !isEmail(email)) {
            this.$toast.info(intl.formatMessage({ id: 'register.check.errorEmail' }))
            return
        }
        if (!imgCode) {
            this.$toast.info(intl.formatMessage({ id: 'register.check.errorImageCode' }))
            return
        }
        const param = {
            phoneNumb: email,
            t: this.store.randomCode,
            code: imgCode,
            language: LANG[getLang()],
            accountType: '2' // 邮箱注册
        }
        this.store.getVerifyCode(param)
    }

    refreshImgCode = e => {
        e.stopPropagation() // 阻止父级的点击事件
        this.store.refreshImgCode()
    }

    handleSignUp = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                if (value.password !== value.rePassword) {
                    this.$toast.info(intl.formatMessage({ id: 'register.check.errorTwoPasswd' }))
                    return
                }
                if (localStorage.getItem('chl') === 'tabletApp' && this.state.operatorId !== 20 && !value.conditions) {
                    return this.$toast.info(intl.formatMessage({ id: 'login.terms' }))
                }
                const param = {
                    phoneNumb: value.email,
                    code: value.verifyCode,
                    password: await encrypt(value.password),
                    accountType: '2', // 邮箱注册 todo 增加firstName 和 lastName
                }
                this.store.handleSignUp(param)
                userStore.sendEventTracing({
                    pageCode: '',
                    buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_REGIST,
                    buttonInfo: ''
                })
            }
        })
    }

    render() {
        const chl = localStorage.getItem('chl')
        const { getFieldProps } = this.props.form;
        return (
            <div className={styles.registerOutWrap}>
                <div style={{ position: 'absolute', right: 15, top: 15, zIndex: 99 }}>
                    <LangSwitch className={styles.switchLangWrap} white />
                </div>
                <div className={styles.registerWrap}>
                    <h4 className={styles.registerTitle}>
                        <FormattedMessage id="register.registerText" />
                    </h4>
                    {/* /!*名*!/*/}
                    <FormItemC form={this.props.form} dataIndex="firstName">
                        <InputItem
                            {...getFieldProps('firstName', {
                                rules: [{
                                    required: true,
                                    validator: (rules, value, callback) => {
                                        if (!value) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.noFirstNameField' })))
                                        } else {
                                            callback()
                                        }
                                    }
                                }]
                            })}
                            placeholder={intl.formatMessage({ id: 'register.input.firstName' })}
                            className={styles.inputItem}
                            clear
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*/!*姓*!/*/}
                    <FormItemC form={this.props.form} dataIndex="lastName">
                        <InputItem
                            {...getFieldProps('lastName', {
                                rules: [{
                                    required: true,
                                    validator: (rules, value, callback) => {
                                        if (!value) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.noLastNameField' })))
                                        } else {
                                            callback()
                                        }
                                    }
                                }]
                            })}
                            placeholder={intl.formatMessage({ id: 'register.input.lastName' })}
                            className={styles.inputItem}
                            clear
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*邮箱 */}
                    <FormItemC form={this.props.form} dataIndex="email">
                        <InputItem
                            {...getFieldProps('email', {
                                rules: [{
                                    required: true,
                                    validator: (rules, value, callback) => {
                                        if (!value) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.noEmailField' })))
                                        } else if (!isEmail(value)) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.errorEmail' })))
                                        } else {
                                            callback()
                                        }
                                    }
                                }]
                            })}
                            placeholder={this.emailPlaceHolder}
                            className={styles.inputItem}
                            clear
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*图片验证码*/}
                    <FormItemC form={this.props.form} dataIndex="imgCode">
                        <InputItem
                            {...getFieldProps('imgCode', {
                                rules: [{
                                    required: true,
                                    validator: (rules, value, callback) => {
                                        const regex = new RegExp(PATTERN.IMGCODE)
                                        if (!value) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.noImageCodeField' })))
                                        } else if (!regex.test(value)) {
                                            callback(new Error(intl.formatMessage({ id: 'register.check.errorImageCode' })))
                                        } else {
                                            callback()
                                        }
                                    }
                                }]
                            })}
                            placeholder={this.imgCodePlaceHolder}
                            className={styles.inputItem}
                            clear
                            extra={<img src={this.store.captchaUrl} onClick={this.refreshImgCode} className={styles.registerCaptcha} />}
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*邮箱验证码*/}
                    <FormItemC form={this.props.form} dataIndex="verifyCode">
                        <InputItem
                            {...getFieldProps('verifyCode', {
                                rules: [{
                                    required: true,
                                    message: intl.formatMessage({ id: 'register.check.noVerifyField' })
                                }]
                            })}
                            placeholder={this.verifyCodePlaceHolder}
                            className={styles.inputItem}
                            clear
                            extra={
                                <span className={styles.getCodeText}>{this.store.title}</span>
                            }
                            onExtraClick={this.getVerifyCode}
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*密码*/}
                    <FormItemC form={this.props.form} dataIndex="password">
                        <InputItem
                            {...getFieldProps('password', {
                                rules: [{
                                    required: true,
                                    message: intl.formatMessage({ id: 'register.check.noPasswdField' })
                                }]
                            })}
                            type={'password'}
                            placeholder={this.passwdPlaceHolder}
                            className={styles.inputItem}
                            clear
                        />
                    </FormItemC>
                    <WhiteSpace className={styles.whiteSpace} />
                    {/*确认密码*/}
                    <FormItemC form={this.props.form} dataIndex="rePassword">
                        <InputItem
                            {...getFieldProps('rePassword', {
                                rules: [{
                                    required: true,
                                    message: intl.formatMessage({ id: 'register.check.noConfirmPasswd' })
                                }]
                            })}
                            type={'password'}
                            placeholder={this.rePasswdPlaceHolder}
                            className={styles.inputItem}
                            clear
                        />
                    </FormItemC>
                    <Button className={styles.registerBtn} onClick={this.handleSignUp}>
                        <FormattedMessage id="register.registerText" />
                    </Button>
                    <p className={styles.registerTip}>
                        {`${intl.formatMessage({ id: 'register.input.alRegister' })},`}
                        <span onClick={() => this.goToPath('/global/login')}>
                            <FormattedMessage id="login.loginText" />
                        </span>
                    </p>
                    {this.state.operatorId !== 20 && (
                        <p className={styles.registerTip} style={{ textAlign: 'left' }}>
                            <FormItemC form={this.props.form} dataIndex="conditions">

                                {chl === 'tabletApp' ?
                                    <CheckboxItem {...getFieldProps('conditions')}>
                                        <FormattedMessage
                                            id="register.tipForTablet"
                                            values={{
                                                a1: chunks => <span
                                                    style={{ textDecoration: 'underline' }}
                                                    onClick={() => this.goToPath(`/global/active-detail`)}
                                                >
                                                    {chunks}
                                                </span>,
                                                a2: chunks => <span
                                                    style={{ textDecoration: 'underline' }}
                                                    onClick={() => window.open('https://www.lenovoconnect.com/en/service/UEM/try-conditions')}
                                                >
                                                    {chunks}
                                                </span>,
                                                a3: chunks => <span
                                                    style={{ textDecoration: 'underline' }}
                                                    onClick={() => window.open('https://www.ckh.com.hk/en/global/tnc.php')}
                                                >
                                                    {chunks}
                                                </span>,
                                                a4: chunks => <span
                                                    style={{ textDecoration: 'underline' }}
                                                    onClick={() => window.open('https://www.lenovoconnect.com/en/service/UEM/try-privacy')}
                                                >
                                                    {chunks}
                                                </span>,
                                                a5: chunks => <span
                                                    style={{ textDecoration: 'underline' }}
                                                    onClick={() => window.open('https://www.ckh.com.hk/en/global/privacy.php')}
                                                >
                                                    {chunks}
                                                </span>,
                                            }}
                                        />
                                    </CheckboxItem>
                                    :
                                    <FormattedMessage
                                        id="register.tip"
                                        values={{
                                            termsOfService: <span
                                                style={{ textDecoration: 'underline' }}
                                                onClick={() => this.goToPath(`/global/en-terms`)}
                                            >{intl.formatMessage({ id: 'register.input.termsOfService' })}
                                            </span>,
                                            privacyStatement: <span
                                                style={{ textDecoration: 'underline' }}
                                                onClick={() => this.goToPath(`/global/en-privacy`)}
                                            >{intl.formatMessage({ id: 'register.input.privacyStatement' })}
                                            </span>
                                        }}
                                    />
                                }
                            </FormItemC>
                        </p>
                    )}

                </div>
            </div>
        )
    }
}

interface FormItemCProps {
    form: any
    children?: any
    dataIndex: string
}

const FormItemC = (props: FormItemCProps) => {
    const { getFieldError } = props.form;
    return (
        <>
            {props.children}
            <span className={styles.errorMessage}>{getFieldError(props.dataIndex)}</span>
        </>
    )
}
export default createForm()(Register)
